import React from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitType, Box, Notification, NotificationType } from 'edenred-ui';

import { SimpleFormStep } from '@epi-pages/LoadBenefit/components/shared/SimpleFormStep';
import { FormStepMode } from '@epi-models/pages/Transfer';
import { TopupAmount } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupAmount';
import { IBenefits } from '@epi-models/pages/BenefitGroups';
import { IBenefitGroupSettings } from '@epi-models/pages/Beneficiaries';
import { TopupAmountProps } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupAmount/TopupAmount';

interface LoadAmountProps extends TopupAmountProps {
  benefitType?: IBenefits;
  lowestYearlyLimit: number;
  benefitSettings?: IBenefitGroupSettings;
  remainingBalance: number;
  daysExceed: boolean;
  daysToTopup?: number;
  stepNumber?: number;
}

export const LoadAmount = ({
  benefitType,
  lowestYearlyLimit,
  benefitSettings,
  remainingBalance,
  daysExceed,
  daysToTopup,
  stepNumber = 3,
  workingDaysValidators,
  showMaxWorkingDaysInfo,
  showOverBalanceWarning
}: LoadAmountProps) => {
  const { t } = useTranslation();

  return (
    <>
      <SimpleFormStep
        mode={FormStepMode.Contained}
        stepNumber={stepNumber}
        stepTitle={t(
          `containers.deposit_money.topup_tab.form.${
            benefitType === BenefitType.lunch ? 'days' : 'amount'
          }.title`
        )}
        pr="70px"
      >
        <TopupAmount
          benefitType={benefitType}
          lowestYearlyLimit={lowestYearlyLimit}
          benefitSettings={benefitSettings}
          remainingBalance={remainingBalance}
          workingDaysValidators={workingDaysValidators}
          showMaxWorkingDaysInfo={showMaxWorkingDaysInfo}
          showOverBalanceWarning={showOverBalanceWarning}
        />
      </SimpleFormStep>
      {daysExceed && (
        <Box mt={5}>
          <Notification
            type={NotificationType.Info}
            text={t(
              'containers.deposit_money.topup_tab.form.days.notification',
              {
                daysToTopup
              }
            )}
          />
        </Box>
      )}
    </>
  );
};
